import * as Template1 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_blue/cdn-function-export';
import * as Template2 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_humanities_architecture_gray/cdn-function-export';
import * as Template3 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_geometry_blue/cdn-function-export';
import * as Template4 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_simple_minimalist_dark/cdn-function-export';
import * as Template5 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_cube_green/cdn-function-export';
import * as Template6 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_geometry_green/cdn-function-export';
import * as Template7 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_blue/cdn-function-export';
import * as Template8 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_darkgold/cdn-function-export';
import * as Template9 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_gray/cdn-function-export';
import * as Template10 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_green/cdn-function-export';
import * as Template11 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_mountain_purple/cdn-function-export';
import * as Template12 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_ray_blue/cdn-function-export';
import * as Template13 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_pink/cdn-function-export';
import * as Template14 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_purple/cdn-function-export';
import * as Template15 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_red/cdn-function-export';
import * as Template16 from '@tencent/docs-design-resources/cooperation/ai/template/template_ppt_techno_silky_yellow/cdn-function-export';

export interface ITemplate {
    id: string;
    cover: string;
}

// TODO 先用之前的4套模板id跑流程，后续更新为新增模板id
export const TEMPLATE_LIST: ITemplate[] = [
    {
        id: 'om151maqs78oxpwx5zgaczwkew',
        cover: 'https://docimg5.docs.qq.com/image/AgAABTW7Ya7KJhVuvpFBD7_j3jd5kBPo.png?w=416&h=233',
    },
    {
        id: 'gbeea8df9iyu3rdtsqjfzeqeca',
        cover: 'https://docimg8.docs.qq.com/image/AgAABTW7Ya6r3PpEKt1Kd58JXbh5CMeA.png?w=416&h=233',
    },
    {
        id: 'y8ynejiubtgsbkj3uok9ey57fh',
        cover: 'https://docimg2.docs.qq.com/image/AgAABTW7Ya7D7YfZtVtI_5_K_8P3UkiE.png?w=416&h=233',
    },
    {
        id: '8gufzibzgbn93pgt8b4g87hubw',
        cover: 'https://docimg1.docs.qq.com/image/AgAABTW7Ya6akm3nB8lDNJXNXJOWJ5e0.png?w=416&h=233',
    },
    {
        id: '5ggds6ajziry7nqqmzmy7fw49h',
        cover: 'https://docimg2.docs.qq.com/image/AgAABTW7Ya5qa7BTqc5OVKFmMiKNZVAe.png?w=416&h=233',
    },
    {
        id: 'd7o87j8757fw3n4od6ce9wd4hr',
        cover: 'https://docimg1.docs.qq.com/image/AgAABTW7Ya70R1gZzMtMR7zKsxQ1tYXi.png?w=416&h=233',
    },
    {
        id: 'm5rwe9b9hfyddqte8egknxfipy',
        cover: 'https://docimg2.docs.qq.com/image/AgAABTW7Ya6N_ipl_9BJEpujxW6fnzqu.png?w=416&h=233',
    },
    {
        id: 'tdy5yi8ob3bgt869c6y7fpnyze',
        cover: 'https://docimg4.docs.qq.com/image/AgAABTW7Ya6gmeUAwvBJRYWDcagghaNV.png?w=416&h=233',
    },
    {
        id: 'wrpsoijgw7yizmfzshx4r438yr',
        cover: 'https://docimg9.docs.qq.com/image/AgAABTW7Ya7bD-sGoRNKL7RuCzv1pUVK.png?w=416&h=233',
    },
    {
        id: 'g6epr8up17bqiqh7gqzrrdikmh',
        cover: 'https://docimg9.docs.qq.com/image/AgAABTW7Ya6z2HRL5xRGyK-xVE4TwFmv.png?w=416&h=233',
    },
    {
        id: 'oknykfwz9pd75jjitujspfy4uc',
        cover: 'https://docimg4.docs.qq.com/image/AgAABTW7Ya6dttjKy8JJGLhGQL1VbJKl.png?w=416&h=233',
    },
    {
        id: 'hepotg7fwfb8tjrmf53rrhestw',
        cover: 'https://docimg3.docs.qq.com/image/AgAABTW7Ya7C4SLg3iBF4502LluNSO-p.png?w=416&h=233',
    },
    {
        id: 's81xj1ypgtnczr43j4bzskdxqy',
        cover: 'https://docimg2.docs.qq.com/image/AgAABTW7Ya4dJc2yWsVK3qkgC66BHO05.png?w=416&h=233',
    },
    {
        id: 'h5bznagh87n49mbaszhhzths3h',
        cover: 'https://docimg9.docs.qq.com/image/AgAABTW7Ya5D87HghSxIzJKb8R53cfqx.png?w=416&h=233',
    },
    {
        id: 'ueu641gwk7nrbk7ozg9wyfuk7h',
        cover: 'https://docimg7.docs.qq.com/image/AgAABTW7Ya5j4PcJeJBF-YDIRpu-QXaa.png?w=416&h=233',
    },
    {
        id: '3wr1pbmdtjrh3jjfzwr75chiya',
        cover: Template7.getTemplateThumbnail1(),
    },
    {
        id: 'gmkecq1xcbgpbesf4w4jrcmz4r',
        cover: Template8.getTemplateThumbnail1(),
    },
    {
        id: 'kdjzibeon3repy5ay4ip9akz5h',
        cover: Template9.getTemplateThumbnail1(),
    },
    {
        id: 'yjp75jdsfbb9frnx6858ro4pgo',
        cover: Template10.getTemplateThumbnail1(),
    },
    {
        id: 'hw9irrrbyjd9jxkh8k6gtgupye',
        cover: Template11.getTemplateThumbnail1(),
    },
    {
        id: 'ujpcqsuz1ifzxno4qckwkhkbir',
        cover: Template12.getTemplateThumbnail1(),
    },
    {
        id: 'fdsgqp5mt7y9fj3qduwh7x7bjy',
        cover: Template13.getTemplateThumbnail1(),
    },
    {
        id: '4wo77tdatif1zkf5up7jagxk9w',
        cover: Template14.getTemplateThumbnail1(),
    },
    {
        id: 'nagpdhr1t7f5bfz8ouwztpjxgw',
        cover: Template15.getTemplateThumbnail1(),
    },
    {
        id: 'o5uw7qdih7bi3drcb1jn4cqo9h',
        cover: Template16.getTemplateThumbnail1(),
    },
    {
        id: 'g4cp6mxhy78uudam11m8zmqt9y',
        cover: Template1.getTemplateThumbnail1(),
    },
    {
        id: '1conbzikijrczy9ypxfn8ygnta',
        cover: Template2.getTemplateThumbnail1(),
    },
    {
        id: 'rmag5z4xstrt3qh7pqi4i7zhzr',
        cover: Template3.getTemplateThumbnail1(),
    },
    {
        id: 'wcihqg1n4jgz7pwewmrddotw8w',
        cover: Template4.getTemplateThumbnail1(),
    },
    {
        id: 'rip96cw6o7yyfqkqihdqp7wzia',
        cover: Template5.getTemplateThumbnail1(),
    },
    {
        id: 'ofidqcx4cjbazcx6nnrq4sfx3o',
        cover: Template6.getTemplateThumbnail1(),
    },
];
